import { Heading, Text, View } from "@instructure/ui";

const HelperHeading = ({ title, stats }) => {
  return (
    <>
      <div
        style={{
          display: "flex",
          gap: "0.5rem",
          justifyContent: "space-between",
          flexWrap: "wrap",
          alignItems: "center",
        }}
      >
        <Heading level="h2">{title}</Heading>
        {stats && <Text>{stats}</Text>}
      </div>
      <View
        as="div"
        borderWidth="0 0 small 0"
        width="100%"
        margin="xxx-small 0 small 0"
      />
    </>
  );
};

export default HelperHeading;
